<div>
  <form [formGroup]="form" (ngSubmit)="save()" autocomplete="off">
    <div class="row">
      <div class="col-4">
        <app-form-group>
          <label translate>CODE</label>
          <input app-form formControlName="cardNumber">
          <app-error-message [control]="form.get('cardNumber')"></app-error-message>
        </app-form-group>
      </div>
      <div class="col-4">
        <app-form-group (click)="d.open()" iconPosition="right" icon="icon-calendar">
          <label translate>TRANSFER_DATE</label>
          <input formControlName="transferDate"
                 outsideDays="collapsed"
                 #transferDate
                 app-form
                 (focus)="stopEvents(transferDate)"
                 autoClose="outside"
                 placement="bottom-right"
                 ngbDatepicker #d="ngbDatepicker"/>
          <app-error-message [control]="form.get('transferDate')"></app-error-message>
        </app-form-group>
      </div>
      <div class="col-4" *ngIf="!!cardTransfer">
        <app-form-group (click)="d2.open()" iconPosition="right" icon="icon-calendar" clear="true">
          <label translate>RETURN_DATE</label>
          <input formControlName="returnDate"
                  navigation="arrows"
                  outsideDays="collapsed"
                  #returnDate
                  app-form
                  (focus)="stopEvents(returnDate)"
                  autoClose="outside"
                  placement="bottom-right"
                  ngbDatepicker #d2="ngbDatepicker"/>
            <app-error-message [control]="form.get('returnDate')"></app-error-message>
        </app-form-group>
      </div>
      <div class="col-4" *ngIf="!!cardTransfer">
        <app-select-input
                        [multiple]="false"
                        [allowClear]="true"
                        formControlName="status"
                        [items]="cardStatus"
                        bindLabel="label"
                        bindValue="value"
                >
                    <label for="" translate>STATUS</label>
                </app-select-input>
      </div>
      <app-error-message [control]="form" [apiError]="formErrors"></app-error-message>
      <div class="py-m d-flex justify-content-between align-items-center">
        <button class="btn btn-primary btn-border w-100 mr-m" (click)="handlerCancel()" translate
                type="button">
          CANCEL
        </button>
        <button class="btn btn-primary w-100" [disabled]="pending" type="submit">
          <app-spinner [showSpinner]="pending"></app-spinner>
          {{('SAVE')|translate}}
        </button>
      </div>

    </div>


  </form>
</div>
